import { Component, OnInit } from '@angular/core';

import { SharedService } from '../../../layouts/shared-service';
// Services
import { CustomerinfobygroupService } from '../../../services/customerinfobygroup.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CustomerGridState } from '../../../store/reducers/customer';
import { Store } from '@ngrx/store';
import { State } from '../../../store/reducers';
import { customerGridSet } from '../../../store/actions/customer';
import { Router } from '@angular/router';
import { getCustomerGridState } from '../../../store/selectors';
import { TagsService } from '../../../services/tags.service';
@Component({
    selector: 'app-group-customers-home',
    styleUrls: ['./group-customers-home.component.scss'],
    templateUrl: './group-customers-home.component.html',
})
export class GroupCustomersHomeComponent implements OnInit {
    // Public Members
    pageTitle = 'Customers';
    customersData: any[];
    customersPricingData: any[];
    chartName = 'Customers';
    customerGridState: CustomerGridState;
    fuelVendors: any[];
    tags: any[];
    selectedTabIndex: number = 0;

    constructor(
        private customerInfoByGroupService: CustomerinfobygroupService,
        private sharedService: SharedService,
        private ngxLoader: NgxUiLoaderService,
        private store: Store<State>,
        private router: Router,
        private tagService: TagsService,
    ) {

    }

    ngOnInit(): void {
        this.loadCustomers();
        this.loadFuelVendors();
        this.loadTags();

        this.store.select(getCustomerGridState).subscribe((state) => {
            this.customerGridState = state;
        });
    }

    editCustomerClicked(event) {
        this.store.dispatch(
            customerGridSet({
                filter: event.filter,
                filterType: event.filterType,
                order: event.order,
                orderBy: event.orderBy,
                page: event.page,
            })
        );

        this.router
            .navigate([
                '/default-layout/customers/' + event.customerInfoByGroupId,
            ])
            .then();
    }

    onCompanyFilterApplied(filter: string[]) {
        if (this.customersData == null || this.customersData.length == 0)
            return;
    }

    onTabChange(index: number) {
        this.selectedTabIndex = index;

        if (index === 0) {
            this.loadCustomers();
        } else if (index === 1) {
            this.loadCustomersPricingGrid();
        }
    }

    // Private Methods
    private loadFuelVendors() {
        this.customerInfoByGroupService
            .getFuelVendors()
            .subscribe((data: any) => {

                this.fuelVendors = data.map((fv) => ({
                    label: fv,
                    value: fv,
                }));
            });
    }

    private loadTags() {
        this.tagService.getGroupTags(
            this.sharedService.currentUser.groupId
        )
            .subscribe((data: any) => {
                this.tags = data.map((tg) => ({
                    label: tg,
                    value: tg,
                }));
            });

    }

    private loadCustomers() {
        this.ngxLoader.startLoader(this.chartName);

        this.customersData = null;

        this.customerInfoByGroupService
            .getCustomersViewModelByGroup(this.sharedService.currentUser.groupId)
            .subscribe((data: any) => {
                //this.customersData = data;

                this.customersData = data.map((c) => ({
                    ...c,
                    fuelVendors: c.fuelVendors.map((fv) => ({
                        label: fv,
                        value: fv,
                    })),
                }));

                this.ngxLoader.stopLoader(this.chartName);

            });
    }

    private loadCustomersPricingGrid() {
        this.ngxLoader.startLoader(this.chartName);

        this.customersPricingData = null;

        this.customerInfoByGroupService
            .getCustomersViewModelByGroupWithPricing(this.sharedService.currentUser.groupId)
            .subscribe((data: any) => {
                //this.customersData = data;

                this.customersPricingData = data.map((c) => ({
                    ...c
                }));

                this.ngxLoader.stopLoader(this.chartName);

            });
    }
}
